module.exports = __webpack_public_path__ + "img/logo.38fd84e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1